export default __webpack_public_path__ + "static/media/raspberrypi.b4526b14.svg";